<template>
  <div class="min-h-screen font-sans transition-colors duration-300">
    <div
      class="bg-background-light dark:bg-background-dark text-slate-800 dark:text-slate-100"
    >
      <main
        class="max-w-7xl mx-auto px-4 py-12 flex flex-col md:flex-row gap-16 items-start"
      >
        <div class="w-full">
          <div class="text-center mb-10">
            <h1
              class="text-3xl text-center font-extrabold text-gray-700 mb-10 tracking-tight title-underline uppercase"
            >
              Silicone Rubber Applications
            </h1>
          </div>

          <!-- <div
            v-for="(item, index) in appList"
            :key="index"
            class="flex flex-col items-center justify-center gap-8 mb-16 pb-12 border-b border-gray-100 last:border-0"
          >
            <h2 class="text-2xl font-bold text-gray-800 mb-4">
              {{ item.title }}
            </h2>
            <div class="w-full lg:w-full flex-shrink-0">
              <img
                :src="item.image"
                :alt="item.title"
                class="w-[70%] h-auto mx-auto object-fit rounded shadow-sm"
              />
            </div>
            <div class="w-full lg:w-[50%]">
              <p class="text-[15px] text-gray-500 leading-relaxed mb-6 italic">
                {{ item.desc }}
              </p>
            </div>
          </div> -->
          <div
            v-for="(item, index) in appList"
            :key="index"
            class="flex flex-col items-center lg:flex-row gap-8 mb-10 pb-10 border-b border-gray-300 last:border-0"
          >
            <div class="w-full lg:w-[40%] flex-shrink-0">
              <img
                :src="item.image"
                :alt="item.title"
                class="w-full h-auto object-fit rounded shadow-sm hover:scale-110 transition-transform duration-500"
              />
            </div>
            <div class="w-full lg:w-[60%]">
              <h2 class="text-2xl font-bold text-gray-800 mb-4">
                {{ item.title }}
              </h2>
              <p class="text-[15px] text-gray-600 leading-relaxed mb-6">
                {{ item.desc }}
              </p>

              <h2 class="font-bold text-gray-800 mb-4">
                Typical applications include:
              </h2>
              <!-- <ul class="pl-[20px] text-[15px] text-gray-600">
                <li v-for="(text, index) in item.purpose" :key="index">
                  {{ text }}
                </li>
              </ul> -->
              <ul
                class="grid grid-cols-2 gap-1 pl-[20px] text-[15px] text-gray-600"
              >
                <li
                  class="pr-1"
                  v-for="(text, index) in item.purpose"
                  :key="index"
                >
                  {{ text }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Applications',
  components: {},
  data() {
    return {
      sideNavs: [
        'Industrial',
        'Medical',
        'Automotive',
        'Electronics',
        'Domestic Products'
      ],
      appList: [
        {
          title: 'Baby Products',
          desc: 'Silicone is uniquely suited for baby products due to its food-grade safety, exceptional softness, and durability. Compliant with strict international standards like FDA and LFGB, it is non-toxic, tasteless, and free of harmful substances such as BPA, making it safe for babies’ sensitive skin and oral contact. Its flexible, resilient texture withstands repeated squeezing, chewing, and sterilization (boiling, steam, or UV), while its smooth surface resists stains and bacteria buildup, ensuring long-lasting hygiene and reliability for items like pacifiers, teething toys, bottle nipples, and feeding utensils.',
          image: require('@/assets/applications/Baby Products.jpg'),
          purpose: [
            'Baby bottles/nipples',
            'Teethers/teething sticks',
            'Complementary food tools',
            'Burping/anti-spitting tools',
            'Cleaning products',
            'Pacifier toys'
          ]
        },
        {
          title: 'Electronics & Electrical',
          desc: 'Silicone rubber is ideally suited for electronic and electrical applications due to its excellent electrical insulation, high temperature stability, and resistance to aging, vibration, and environmental factors. It maintains reliable performance across extreme temperatures, prevents dust and salt spray from damaging components, and delivers durable sealing and shock absorption. These properties ensure it can protect sensitive electronics from moisture, contaminants, and mechanical stress over long-term use.',
          image: require('@/assets/applications/Electronics Electrical.jpg'),
          purpose: [
            'Wire and cable insulators, potentiometer insulation sleeves and sealing rings',
            'Cable accessories, indoor/outdoor terminals, and sheaths',
            'Socket leakage protection seals',
            'Smartphone cases, keyboard covers',
            'Buttons, component fixings, and sealing rings for household appliances (washing machines, refrigerators, etc.)',
            'Conductive connectors for electronic equipment'
          ]
        },
        {
          title: 'Home Applications',
          desc: 'Silicone is ideal for household products due to its versatile, durable, food-grade safe properties. Heat-resistant (withstanding boiling and microwave temperatures without deformation or harmful emissions), it is flexible yet resilient, stain- and odor-resistant, and easy to clean. Its excellent waterproof, airtight sealing and moldability also make it perfect for crafting a wide range of items, from ice trays and kitchenware to gaskets and bath accessories.',
          image: require('@/assets/applications/Home Applications.jpg'),
          purpose: [
            'Ice cube trays',
            'Kitchenware',
            'Tableware',
            'Coin purses',
            'Hot water bags',
            'Water cup lid gaskets',
            'Special anti-overflow gaskets for kitchens',
            'Bath scrubbers',
            'Mask brushes'
          ]
        },
        {
          title: 'Medical Care',
          desc: 'Silicone rubber is widely used in medical applications due to its unique combination of properties:  high biocompatibility, chemical stability, resistance to high-temperature sterilization, as well as being soft, elastic, and breathable. Combined with high purity, mechanical durability, and the ability to be molded into precise, complex shapes, it meets the strict safety and functionality demands of modern medical devices.',
          image: require('@/assets/applications/Medical Care.jpg'),
          purpose: [
            'Dental/surgical devices',
            'Fluid and drug delivery devices',
            'Septa / stoppers / laboratory accessories',
            'Medical tubing',
            'Dialysis o-rings',
            'Seals / o-rings / valves',
            'Respiratory/anesthesia',
            'Medical equipment keypads'
          ]
        },
        {
          title: 'Power Engineering',
          desc: 'Silicone rubber is uniquely suited for power engineering applications due to its excellent electrical insulation properties, exceptional thermal stability, and robust resistance to environmental stress. It maintains high dielectric strength even under high-voltage and high-frequency conditions, preventing electrical breakdown and ensuring reliable insulation for power transmission and distribution equipment. Its ability to withstand extreme temperatures, UV radiation, ozone, and salt spray makes it highly durable in outdoor and harsh industrial environments, while its flexibility and resistance to cracking and aging ensure long-term performance for components like cable accessories, insulator housings, and high-voltage bushings.',
          image: require('@/assets/applications/Power Engineering.jpg'),
          purpose: [
            'Cable accessories',
            'cold shrink tubing',
            'wall  sleeves',
            'plug-in  heads',
            'Transformer sheaths',
            'high and low voltage electrical accessories',
            'Insulators and lightning arresters'
          ]
        }
      ]
    }
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
[v-cloak] {
  display: none;
}
html {
  scroll-behavior: smooth;
}
/* 这里的高度需根据导航栏高度微调，确保吸顶时不遮挡文字 */
.sticky-sidebar {
  position: -webkit-sticky;
  position: sticky;
  top: 100px;
}
ul {
  list-style-type: disc;
}
.title-underline {
  position: relative;
  display: inline-block;
}
.title-underline::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -10px;
  width: 100%;
  height: 8px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 20" preserveAspectRatio="none"><path d="M0 15 Q 25 5, 50 15 T 100 15" stroke="%23004494" stroke-width="4" fill="transparent"/></svg>');
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/page/applications/Applications.vue